import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CareGuideForm from '../containers/CareGuideFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import QueryString from '../../../../../lib/QueryString';
import Logger from '../../../../../lib/Logger';

class CareGuideAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CareGuideAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    const urlParams = QueryString.parse(this.props.location.search);
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('care_guide_route_add')} />
          <CareGuideForm copyId={'copyId' in urlParams ? urlParams.copyId : false} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuideAddScreen;

Logger.log('silly', `CareGuideAddScreen loaded.`);
